export const INITIAL_NUMBER_OF_COLUMNS = 5;
export const DYNAMIC_COLUMNS_TABLE_COLUMN_WIDTH = 280;
export const ANTD_TABLE_HEADER_CLASS = 'ant-table-header';
export const ANTD_TABLE_CONTAINER_CLASS = 'ant-table-container';
